module.exports = "/images/Icon industry-movie.svg?8e8f15d02d28caffe24c2473294be7e2";